import myaxios from '../utils/myaxios'

export function crDev(data) {
    return myaxios({
        url: '/manager/device-info/crDev',
        data,
        method: "post"
    })
}

export function onOffDevice(data) {
    return myaxios({
        url: '/manager/device-info/onOffDevice',
        data,
        method: "post"
    })
}

export function queryDeviceList(data) {
    return myaxios({
        url:'/manager/device-info/query-device-list',
        data,
        method: 'post'
    })
}

export function querySetupCodeList(data) {
    return myaxios({
        url:'/manager/setupCode-info/query-setupCode-List',
        data,
        method: 'post'
    })
}


export function exportExcel(data) {
    return myaxios({
        url: '/manager/device-info/upload-device-list',
        data,
        method: "post"
    })
}

export function resetDevice(data) {
    return myaxios({
        url: '/manager/device-info/reset-device',
        data,
        method: "post"
    })
}

export function defaultCard(data) {
    return myaxios({
        url: '/manager/device-info/defaultCard',
        data,
        method: "post"
    })
}

export function queryTemplateCodeList(data) {
    return myaxios({
        url: '/manager/templateCode-info/query-templateCode-List',
        data,
        method: 'post'
    })
}

export function saveTemplateCode(data) {
    return myaxios({
        url: '/manager/templateCode-info/saveTemplateCode',
        data,
        method: 'post'
    })
}

export function delTemplateCode(data) {
    return myaxios({
        url: '/manager/templateCode-info/delTemplateCode',
        data,
        method: 'post'
    })
}

export function getTemplateCode(data) {
    return myaxios({
        url: '/manager/templateCode-info/getTemplateCode',
        data,
        method: 'post'
    })
}

export function saveSetupCode(data) {
    return myaxios({
        url: '/manager/setupCode-info/saveSetupCode',
        data,
        method: 'post'
    })
}

export function updSetupCode(data) {
    return myaxios({
        url: '/manager/setupCode-info/updSetupCode',
        data,
        method: 'post'
    })
}

export function delSetupCode(data) {
    return myaxios({
        url: '/manager/setupCode-info/delSetupCode',
        data,
        method: 'post'
    })
}


export function queryDeviceCodeList(data) {
    return myaxios({
        url:'/manager/deviceCode/query-device-code',
        data,
        method: 'post'
    })
}

export function exportExcelCode(data) {
    return myaxios({
        url: '/manager/deviceCode/upload-device-code',
        data,
        method: "post"
    })
}


export function batchBuyPacket(data) {
    return myaxios({
        url: '/manager/device-info/batchDeviceBag',
        data,
        method: 'post'
    })
}


export function getBagInfo(url) {
    return myaxios({
        url: url,
        method: 'get'
    })
}


export function postBuyPacket(data) {
    return myaxios({
        url: '/manager/device-info/device-recharge',
        data,
        method: 'post'
    })
}


export function queryPackageDescInfoActive(data) {
    return myaxios({
        url: '/manager/device-info/queryPackageDeviceInfo',
        data,
        method: 'post'
    })
}